import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./Root";
import loadServices from "./out-services";
import "./sentry";

ReactDOM.render(<Root />, document.getElementById("root"), () => {
  if (process.env.NODE_ENV === "production") {
    loadServices();
  }
});
